<template>
  <PageTemplate>
    <form
      @submit.prevent="saveChanges"
      @change="handleChange"
      @invalid.capture.prevent="handleInvalid"
    >
      <div class="row">
        <div class="col-lg-6">
          <h1>Edit Profile</h1>
        </div>
        <div class="col-lg-6">
          <v-button-group is-right>
            <v-button
              size="lg"
              color="secondary"
              has-min-width
              @click="$router.push('/change-password')"
            >
              Change Password
            </v-button>
            <v-button
              size="lg"
              :is-disabled="!canSave"
              has-min-width
              is-submit
            >
              Save Changes
            </v-button>
          </v-button-group>
        </div>
      </div>
      <div class="row">
        <div
          v-if="!isUserHasTARole()"
          class="row"
        >
          <div class="col-lg-6">
            <v-card title="Details">
              <v-fieldset
                id="first_name"
                v-model="info.first_name"
                name="first_name"
                text="First Name*"
                type="text"
                is-required
                :help-text="fieldErrors.first_name"
              />
              <v-fieldset
                id="last_name"
                v-model="info.last_name"
                name="last_name"
                text="Last Name*"
                type="text"
                is-required
                :help-text="fieldErrors.last_name"
              />
              <v-fieldset
                id="email"
                v-model="info.email"
                name="email"
                text="Email Address*"
                type="email"
                is-required
                :help-text="fieldErrors.email"
              />
              <v-fieldset
                id="mobile_number"
                v-model="info.mobile_number"
                name="mobile_number"
                text="Phone*"
                type="text"
                is-required
                :help-text="fieldErrors.mobile_number"
              />
            </v-card>
          </div>
          <div class="col-lg-6">
            <v-card title="Address Details">
              <div class="row">
                <v-fieldset
                  id="address"
                  v-model="info.address"
                  name="address"
                  class="col-12"
                  text="Address*"
                  type="text"
                  is-required
                  :help-text="fieldErrors.address"
                />
                <v-fieldset
                  id="country"
                  v-model="info.country"
                  name="country"
                  class="col-lg-6"
                  text="Country"
                  type="text"
                />
                <v-fieldset
                  v-if="states.length > 0"
                  id="state"
                  v-model="info.state"
                  name="state"
                  class="col-lg-6"
                  text="State"
                  :select-options="states"
                  :disabled="stateDisabled"
                />
                <v-fieldset
                  id="suburb"
                  v-model="info.suburb"
                  name="suburb"
                  class="col-lg-6"
                  text="Suburb"
                  type="text"
                />
                <v-fieldset
                  id="postcode"
                  v-model="info.postcode"
                  name="postcode"
                  class="col-lg-6"
                  text="Post Code"
                  type="text"
                />
              </div>
            </v-card>
          </div>
        </div>
        <div
          v-else
          class="row"
        >
          <!-- TA Profile
          {{ info }}
          <br> -->
          <div class="col-md-6 d-flex">
            <v-card title="Personal Details">
              <v-fieldset
                id="title"
                v-model="info.title"
                name="title"
                text="Position Title"
                type="text"
                :help-text="fieldErrors.title"
              />
              <v-fieldset
                id="first_name"
                v-model="info.first_name"
                name="first_name"
                text="First Name*"
                type="text"
                is-required
                :help-text="fieldErrors.first_name"
              />
              <v-fieldset
                id="last_name"
                v-model="info.last_name"
                name="last_name"
                text="Last Name*"
                type="text"
                is-required
                :help-text="fieldErrors.last_name"
              />
            </v-card>
          </div>
          <div class="col-md-6 d-flex">
            <v-card title="Competency Details">
              <v-button
                size="lg"
                :disabled="isCOmpetencyPDFUploaded()"
                has-min-width
                @click="viewTACompetency"
              >
                View Competencies
              </v-button>
              <v-fieldset
                id="last_name"
                v-model="competency.suggestChanges"
                name="last_name"
                text="Suggest Changes"
                type="textarea"
              />
              <strong class="orcls">And if required</strong>
              <v-button
                v-if="!competency.orgDoc"
                size="lg"
                has-min-width
                @click="$refs.uploadmodal.openModal()"
              >
                Upload a document with suggested changes to competencies
              </v-button>
              <div
                v-else
                class="par-div-temp-link"
              >
                <a
                  class="temp-link"
                  :href="uploadedDocSignedURL"
                  target="_blank"
                >
                  {{ competency.orgDoc }}
                </a>
                <v-button
                  color="secondary"
                  size="sm"
                  @click="removeUploadedCompetencySuggestDocument"
                >
                  <v-icon type="trash" />
                </v-button>
              </div>
            </v-card>
          </div>
          <div class="col-md-6 d-flex">
            <v-card title="Email Details">
              <div class="col-md-12 d-flex gap-in-list">
                <div class="col-md-2">
                  Type
                </div>
                <div class="col-md-8">
                  Email
                </div>
                <div class="col-md-2 primaryTitle">
                  Primary
                </div>
              </div>
              <div
                v-for="(item, index) in info.user_info.csv_info.emails"
                :key="item.Type"
                class="col-md-12 d-flex gap-in-list"
              >
                <div class="col-md-2">
                  <strong>{{ `${item.Type}${item.isPrimary?'*':''}` }}</strong>
                </div>
                <div class="col-md-8">
                  <!-- {{ item }} -->
                  <v-fieldset
                    :id="`email_${index}`"
                    v-model="item.email"
                    :name="`${item.Type}_email`"
                    type="email"
                    pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$"
                    :is-required="item.isPrimary"
                    :help-text="fieldErrors[`${item.Type}_email`]"
                  />
                </div>
                <div class="col-md-2 primaryTitle">
                  <input
                    id="email_isPrimary"
                    name="email_isPrimary"
                    class="following__control"
                    type="radio"
                    :checked="item.isPrimary"
                    @change="(e) => primaryOptionChange('emails', e, item.Type, index)"
                  >
                </div>
              </div>
            </v-card>
          </div>
          <div class="col-md-6 d-flex">
            <v-card title="Phone Details">
              <div class="col-md-12 d-flex gap-in-list">
                <div class="col-md-2">
                  Type
                </div>
                <div class="col-md-8">
                  Phone
                </div>
                <div class="col-md-2 primaryTitle">
                  Primary
                </div>
              </div>
              <div
                v-for="(item, index) in info.user_info.csv_info.phones"
                :key="`Phone_${item.Type}`"
                class="col-md-12 d-flex gap-in-list"
              >
                <div class="col-md-2">
                  <strong>{{ `${item.Type}${item.isPrimary?'*':''}` }}</strong>
                </div>
                <div class="col-md-8">
                  <!-- {{ item }} -->
                  <div class="row">
                    <div class="col-md-3">
                      <v-fieldset
                        :id="`${item.Type}_countryCode`"
                        v-model="item.countryCode"
                        :name="`${item.Type}_countryCode`"
                        type="text"
                        pattern="[+]\d*"
                        :is-required="item.isPrimary"
                        :help-text="fieldErrors[`${item.Type}_countryCode`]"
                      />
                    </div>
                    <div class="col-md-9">
                      <v-fieldset
                        :id="`${item.Type}_phoneNumber`"
                        v-model="item.phoneNumber"
                        :name="`${item.Type}_phoneNumber`"
                        type="text"
                        pattern="\d*"
                        :is-required="item.isPrimary"
                        :help-text="fieldErrors[`${item.Type}_phoneNumber`]"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-2 primaryTitle">
                  <input
                    id="phone_isPrimary"
                    name="phone_isPrimary"
                    class="following__control"
                    type="radio"
                    :checked="item.isPrimary"
                    @change="(e) => primaryOptionChange('phones', e, item.Type, index)"
                  >
                </div>
              </div>
            </v-card>
          </div>
          <div
            v-for="(item, index) in info.user_info.csv_info.addresses"
            :key="index"
            class="col-md-6 d-flex"
          >
            <v-card
              :title="getAddressTitle(item)"
            >
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="address-primary"
                  >
                    Primary&nbsp;&nbsp;&nbsp;
                    <input
                      id="address_isPrimary"
                      name="address_isPrimary"
                      class="following__control"
                      type="radio"
                      :checked="item.isPrimary"
                      @change="(e) => primaryOptionChange('addresses', e, item.Type, index)"
                    >
                  </div>
                </div>
                <div class="col-md-12">
                  <!-- Address details here! {{ item }}
                  <br> -->
                  <v-fieldset
                    :id="`${item.Type}_AddressLine`"
                    v-model="item.AddressLine"
                    :name="`${item.Type}_AddressLine`"
                    :text="`Address${item.isPrimary?'*':''}`"
                    type="text"
                    :is-required="item.isPrimary"
                    :help-text="fieldErrors[`${item.Type}_AddressLine`]"
                  />
                  <div class="row">
                    <div class="col-md-6">
                      <v-fieldset
                        :id="`${item.Type}_Country`"
                        v-model="item.Country"
                        :name="`${item.Type}_Country`"
                        :text="`Country${item.isPrimary?'*':''}`"
                        type="text"
                        :is-required="item.isPrimary"
                        :help-text="fieldErrors[`${item.Type}_Country`]"
                        @input="(e)=>countryChange(e, item)"
                      />
                    </div>
                    <div class="col-md-6">
                      <v-fieldset
                        v-if="states.length > 0"
                        :id="`${item.Type}_State`"
                        v-model="item.State"
                        :name="`${item.Type}_State`"
                        class="col-lg-12"
                        text="State"
                        :select-options="states"
                        :disabled="addressTypeStatesDisabled[`${item.Type}_State`]"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <v-fieldset
                        :id="`${item.Type}_Suburb`"
                        v-model="item.Suburb"
                        :name="`${item.Type}_Suburb`"
                        :text="`Suburb${item.isPrimary?'*':''}`"
                        type="text"
                        :is-required="item.isPrimary"
                        :help-text="fieldErrors[`${item.Type}_Suburb`]"
                      />
                    </div>
                    <div class="col-md-6">
                      <v-fieldset
                        :id="`${item.Type}_Postcode`"
                        v-model="item.Postcode"
                        :name="`${item.Type}_Postcode`"
                        :text="`Post Code${item.isPrimary?'*':''}`"
                        type="text"
                        pattern="\d*"
                        :is-required="item.isPrimary"
                        :help-text="fieldErrors[`${item.Type}_Postcode`]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </div>
      <v-button
        color="transparent"
        @click="performCancel()"
      >
        Cancel
      </v-button>
    </form>
    <v-spinner
      v-if="isLoading"
      is-full
    />
    <v-uploadmodal
      ref="uploadmodal"
      :is-description-required="false"
      @upload="upload"
    />
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page/index.vue";
  import Button from "@/atoms/Button";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Card from "@/molecules/Card";
  import Fieldset from "@/molecules/Fieldset";
  import {buildBreadCrumb} from "../common/tableFunctions";
  import Spinner from "@/atoms/Spinner";
  import {GET_USER, UPDATE_PROFILE} from "@/store/actions.type";
  import Icon from "@/atoms/Icon";
  import constants from "@/common/constants";
  import ApiService from "@/common/apiService";
  import routes from "@/common/routes";
  import _ from 'lodash';
  import UploadModal from "@/organisms/UploadModal";

  export default {
    name: "EditProfile",
    components: {
      'v-button': Button,
      'v-button-group': ButtonGroup,
      'v-fieldset': Fieldset,
      'v-card': Card,
      "v-spinner": Spinner,
      "v-uploadmodal": UploadModal,
      "v-icon": Icon,
      PageTemplate
    },
    data: () => ({
      states: constants.USER_STATES,
      canSave: false,
      stateDisabled: false,
      emailError: null,
      isLoading: false,
      fieldErrors: {},
      info: {country:''},
      addressTypeStatesDisabled: [],
      competency: {
        suggestChanges: null,
        document: null,
        orgDoc: null
      },
      uploadedDocSignedURL: null,
    }),
    computed: {
    },
    watch: {
    },
    beforeMount() {
      this.info = JSON.parse(JSON.stringify(this.$store.getters.getUser));
    },
    mounted() {
      this.updateBreadCrumb();
      setTimeout(()=>{this.enableDisableStateOnInitialLoad()}, 100);
    },
    methods: {
      isUserHasTARole() {
        let user = this.$store.getters.getUser;
        if(!user || !user.roles) {
          return false;
        }
        let res = user.roles.filter(ele => {
                if(ele.id === constants.NATA_ROLE_TA_ID)
                  return true;
                return false;
              }).length > 0 && user.user_info?true:false;
        return res;

      },
      getTypeFromId(id) {
        return id.substring(0, id.indexOf('_'));
      },
      isCountryIsAustralia(country) {
        return country.toString().toLowerCase() === 'australia' || country.toString().toLowerCase() === 'au'
      },
      countryChange(evt, addressItem) {
        this.addressTypeStatesDisabled[`${addressItem.Type}_State`] = !this.isCountryIsAustralia(addressItem.Country);
        if(this.addressTypeStatesDisabled[`${addressItem.Type}_State`]) {
          addressItem.State = 'Other';
        }
      },
      resetStates() {
        this.states = constants.USER_STATES;
      },
      performCancel() {
        this.$router.push('/profile');
      },
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Profile'] = routes.PROFILE;
        breadcrumbs['Edit Profile'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      saveChanges: function () {
        let params = this.cleanObj({...this.info});
        if(this.isUserHasTARole() && ((this.competency.suggestChanges !== null && this.competency.suggestChanges.trim() !== '') || this.competency.document !== null)) {
          if(params)
            params.competency = this.competency;
          else {
            params = {
              id: this.$store.getters.getUser.id,
              resource_id: this.$store.getters.getUser.resource_id,
              competency: this.competency
            }
          }
        }
        if(!params) {
          this.canSave =  false;
          return;
        }
        this.isLoading = true;
        this.$store.dispatch(UPDATE_PROFILE, {params})
          .then(response => {
            this.isLoading = false;
            this.$notify({
              title: 'Success',
              text: 'Your profile request has been submitted to NATA for approval!',
              type: 'success',
              duration: 5000
            });
            //  refresh state and redirect to profile page
            this.$router.push(routes.PROFILE);
          })
          .catch(error => {
            this.isLoading = false;
            for (const [key, value] of Object.entries(error.data.data)) {
              this.$notify({
                title: 'Error',
                text: value[0],
                type: 'error'
              });
            }
          })
      },
      handleChange(evt) {
        this.canSave = false;
        this.canSave = !_.isEqual(this.$store.getters.getUser, this.info);
        // check if competency suggest is changed.
        if((this.competency.suggestChanges !== null && this.competency.suggestChanges.trim() !== '') || this.competency.document !== null) {
           this.canSave = true;
        }
        if(evt)
          this.fieldErrors = {
            ...this.fieldErrors,
            [evt.target.name]: ""
          };
      },
      handleInvalid(evt) {
        this.fieldErrors = {
          ...this.fieldErrors,
          [evt.target.name]: evt.target.validationMessage
        };
      },
      cleanObj: function (obj) {
        let res = {};
        // If there is no change in user_if then also delete it
        if(_.isEqual(obj.user_info, this.$store.getters.getUser.user_info)) {
          delete obj['user_info'];
        }

        delete obj['committeeAdmin'];
        delete obj['roles'];
        delete obj['committees'];

        for (var propName in obj) {
          if(obj[propName] !== this.$store.getters.getUser[propName]) {
            res[propName] = obj[propName];
            if(propName == 'user_info') {
              this.checkAndUpdateUserInfoProperties(obj);
            }
          }
        }
        if(Object.keys(res).length > 0) {
          res.id = this.$store.getters.getUser.id;
          res.resource_id = this.$store.getters.getUser.resource_id;
        }else {
          return false;
        }
        return res;
      },
      checkAndUpdateUserInfoProperties(obj) {
        if(_.isEqual(obj.user_info.csv_info, this.$store.getters.getUser.user_info.csv_info)) {
          delete obj.user_info;
        }
        if(_.isEqual(obj.user_info.csv_info.emails, this.$store.getters.getUser.user_info.csv_info.emails)) {
          delete obj.user_info.csv_info.emails;
        }
        if(_.isEqual(obj.user_info.csv_info.phones, this.$store.getters.getUser.user_info.csv_info.phones)) {
          delete obj.user_info.csv_info.phones;
        }
        if(_.isEqual(obj.user_info.csv_info.addresses, this.$store.getters.getUser.user_info.csv_info.addresses)) {
          delete obj.user_info.csv_info.addresses;
        }
        if(!obj.user_info.csv_info.emails && !obj.user_info.csv_info.phones && !obj.user_info.csv_info.addresses) {
          delete obj.user_info;
        }
      },
      getAddressTitle(item) {
        return item.Type + ' Address';
      },
      isCOmpetencyPDFUploaded() {
        return !(this.info.user_info && this.info.user_info.competency_pdf_uri && this.info.user_info.competency_pdf_uri.indexOf(this.info.resource_id) !== -1);
      },
      viewTACompetency() {
        ApiService.get("/activeuser/competencypdf")
                .then(response => {
                    if(response.data.data)
                      window.open(response.data.data, '_blank');
                    else
                      this.$notify({
                        title: 'Error',
                        text:'Competency PDF is not available yet. Please contact administrator.',
                        type: 'error'
                      });
                })
                .catch(error => {
                  this.$notify({
                      title: 'Error',
                      text:'Competency PDF is not available yet. Please contact administrator.',
                      type: 'error'
                    });
                });
      },
      primaryOptionChange(obj, e, type, index) {
        this.info.user_info.csv_info[obj].forEach(ele => {
          if(ele.Type == type) {
            ele.isPrimary = true;
          }else
            ele.isPrimary = false;

        });
      },
      getValueFromUserObject(obj, type) {
        return this.$store.getters.getUser.user_info.csv_info[obj].find(ele => {
          return ele.Type == type;
        });
      },
      getFileName(fileName) {
        return this.info.id+'_'+this.info.user_info.id+'_'+(new Date()).getTime()+'_'+fileName;
      },
      async upload(file, fileDescription) {
        var formData = new FormData();
        formData.append('file', file);
        formData.append('fileName', this.getFileName(file.name));
        ApiService.post("/user-requests/edittacompetencydoc", formData)
          .then(({ data }) => {
            if(data.success) {
              this.competency.orgDoc = file.name;
              this.competency.document = data.data.fileName;
              this.uploadedDocSignedURL = data.data.signedUrl;
              this.handleChange(false);
            }
            this.$notify({
              title: 'Success',
              text: 'Document uploaded successfully.',
              type: 'success'
            });
          })
          .catch(({ response }) => {
            this.$notify({
              title: 'Error',
              text: response.data.message?response.data.message:'Unable to upload selected document. Try again or contact administrator.',
              type: 'error'
            });
          }).finally(()=> {
            this.$refs.uploadmodal.closeModal();
          })
      },
      async removeUploadedCompetencySuggestDocument () {
        var formData = new FormData();
        formData.append('fileName', this.competency.document);
        ApiService.post("/user-requests/removeUploadedCompetencySuggestDocument", formData)
          .then(({ data }) => {
            this.$notify({
              title: 'Success',
              text: 'Document removed successfully.',
              type: 'success'
            });
          })
          .catch(({ response }) => {
            this.$notify({
              title: 'Error',
              text: response.data.message?response.data.message:'Unable to remove document. Try again or contact administrator.',
              type: 'error'
            });
          }).finally(()=> {
            this.competency.document = null;
            this.competency.orgDoc = null;
            this.handleChange(false);
          });

      },
      enableDisableStateOnInitialLoad() {
        this.info.user_info.csv_info.addresses.forEach(e => {
          this.countryChange(null, e);
        });
        this.$forceUpdate();
      }

    }
  }
</script>
<style lang="scss">

  .orcls {
    margin-top: -20px;
    margin-bottom: 0px;
    width:100%;
    display: flex;
    justify-content: center;
  }
  .gap-in-list {
    margin-bottom: 1rem;
  }
  .temp-link {
    color: #0076ff;
    margin: 2px;
  }
  .par-div-temp-link {
    display: flex;
    justify-content: space-between;
    background: aliceblue;
  }
</style>
